import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Table, Pagination, Button, Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import RoundedPagination from "../../Components/Paginate";
import { Link, useNavigate } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import { logout } from "../../redux/actions/AuthActions";
import useDebounce from "../../hooks/useDebounce";
import { getDisplayDateTimeFormat } from "../../util/generalUtills";
import PageTitle from "../../Components/PageTitle";
import Preloader from "../../Components/Preloader";
import { deleteProduct, getProductList } from "../../redux/actions/ManageProductActions";
import AddProduct from "../../Components/FormComponent/AddProduct";

const Dashboard = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [editProductId, setEditProductId] = useState(null);
    const [productListing, setProductListing] = useState(null);
    const [productID, setProductID] = useState(null);
    const {
        AuthReducer: { auth, errors, loading },
        productReducer: {
            productLists,
            loadingProduct,
            errorsProduct,
            changedProductStatus,
        },
    } = useSelector((product) => product);
    const [page, setPage] = useState(1);
    const [paginate, setPaginate] = useState(1);
    const [total, setTotal] = useState("");
    const [search, setSearch] = useState("");
    const [sort, setSort] = useState('desc');
    const indexOfLastItem = (page + 1) * paginate;
    const indexOfFirstItem = indexOfLastItem - paginate;


    useEffect(() => {
        if (productLists) {
            setProductListing(productLists?.data);
            setPage(productLists?.current_page);
            setTotal(productLists?.total);
            setPaginate(productLists?.per_page);
        }
    }, [productLists])

    const hideModel = () => {
        setShowModal(false);
        setProductID(null);
        dispatch(getProductList(auth.token, paginate, page, search, sort));
    };

    const fetchProductList = useCallback(() => {
        if (auth?.token) {
            dispatch(getProductList(auth.token, paginate, page, search, sort));
        }
    }, [auth, paginate, page, search, sort, dispatch]);

    useDebounce(fetchProductList, 500, [auth, paginate, page, search, sort]);

    useEffect(() => {
        if (errors) {
            if (errors?.status == 401) {
                dispatch(logout())
                toast.error(errors?.data?.message);
                navigate('/login');
                window.location.reload();
            }
        }
    }, [errors])



    const handlePaginateChange = (e) => {
        const value = e.target.value === "All" ? total : parseInt(e.target.value);
        setPaginate(value);
        setPage(1);
    };

    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    };

    const handleDeleteRequest = (id) => {
        swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28bb4b",
            cancelButtonColor: "#f34e4e",
            confirmButtonText: "Yes, delete it!",
        })
            .then((result) => {
                if (result.isConfirmed) {
                    dispatch(deleteProduct(auth?.token, id))
                }
            });
    };

    const handleStatusChangeRequest = (id, newStatus) => {
        swal.fire({
            title: "Are you sure?",
            text: `Do you want to change the status to ${newStatus}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28bb4b",
            cancelButtonColor: "#f34e4e",
            confirmButtonText: "Yes, change it!",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(updateCityStatusData(auth.token, id, newStatus));
            }
        });
    };


    useEffect(() => {
        if (changedProductStatus?.status) {
            swal.fire({
                show: true,
                title: "Deleted!",
                text: changedProductStatus?.message,
                icon: "success",
                showConfirmButton: false,
                timer: 1500
            });
            dispatch({ type: 'RESET_DELETE_PRODUCT_STATUS' });
            dispatch(getProductList(auth?.token, paginate, page, search, sort));
        }
        else if (changedProductStatus?.success) {
            swal.fire({
                show: true,
                title: "Great !",
                text: changedProductStatus?.message,
                icon: "success",
                showConfirmButton: false,
                timer: 1500
            });
            dispatch({ type: 'RESET_DELETE_PRODUCT_STATUS' });
            dispatch(getProductList(auth?.token, paginate, page, search, sort));
        }
    }, [changedProductStatus])




    return (
        <>
            <PageTitle
                breadCrumbItems={[
                    { label: t("Manage Products"), path: "/", active: true },
                ]}
                title={t("Manage Products")}
            />

            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <div className="mb-2">
                                <Row>
                                    <Col lg={3}>
                                        <div className="d-flex align-items-center">

                                            <input
                                                type="search"
                                                placeholder="Search..."
                                                className="form-control ms-1"
                                                autoComplete="off"
                                                value={search}
                                                onChange={handleSearchChange}
                                            />


                                        </div>
                                    </Col>
                                    <Col lg={9}>
                                        <div className="d-flex justify-content-end align-items-center">
                                            <div className="button-list">

                                                <Button variant="success" onClick={() => {
                                                    setShowModal(true)
                                                    setProductID(null)
                                                }} >
                                                    <i className="mdi mdi-clipboard-plus-outline me-1"></i>Add
                                                </Button>
                                                {/* <Button variant="dark">
                                                    <i className="mdi mdi-printer me-1"></i>Print
                                                </Button>

                                                <Button variant="info">
                                                    <i className="mdi mdi-file-excel me-1"></i>Excel
                                                </Button> */}

                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            <div>
                                <Table className="mb-0 table-sm" responsive="sm" striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Sr No.</th>
                                            <th>Name</th>
                                            <th>Price</th>
                                            <th>Video URL</th>
                                            <th>Image</th>
                                            <th>Manufactured By</th>
                                            <th>Location</th>
                                            <th>Description</th>
                                            <th>Status</th>
                                            <th>Registered At</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productListing?.length === 0 ? (
                                            <tr>
                                                <td colSpan="14">No data found</td>
                                            </tr>
                                        ) : (
                                            <>
                                                {productListing?.map((item, index) => {
                                                    return (
                                                        <tr key={item.id}>
                                                            <th scope="row">{index + 1 + (page - 1) * paginate}</th>
                                                            <td>{item?.name}</td>
                                                            <td>{item?.price}</td>
                                                            <td><a href={item?.video_url} target="_blank" rel="noopener noreferrer"> View Video </a> </td>
                                                            <td>
                                                                <img
                                                                    src={`https://msmesupplier.s3.ap-south-1.amazonaws.com/${item?.image}`}
                                                                    alt={item?.name}
                                                                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                                />
                                                            </td>
                                                            <td>{item?.manufactured_by}</td>
                                                            <td>{item?.location}</td>
                                                            <td>{item?.description}</td>
                                                            <td>
                                                                {item?.status == "0" ? (
                                                                    <Badge className={"bg-danger"}>Unapproved</Badge>
                                                                ) : (
                                                                    <Badge className={"bg-success"}>Approved</Badge>
                                                                )}
                                                            </td>
                                                            <td>{getDisplayDateTimeFormat(item?.createdAt)}</td>

                                                            <td>
                                                                {item?.status == "0" ? (<>
                                                                <Link
                                                                    to="#"
                                                                    onClick={() => {
                                                                        setShowModal(true);
                                                                        setProductID(item?.id);
                                                                    }}
                                                                    className="action-icon text-info"
                                                                >
                                                                    <i className="mdi mdi-square-edit-outline"></i>
                                                                </Link>

                                                                <Link
                                                                    to="#"
                                                                    onClick={() => handleDeleteRequest(item?.id)}
                                                                    className="action-icon text-danger"
                                                                >
                                                                    <i className="mdi mdi-delete"></i>
                                                                </Link>
                                                                </>
                                                                ):""}

                                                            </td>

                                                        </tr>
                                                    );
                                                })}
                                            </>
                                        )}
                                    </tbody>
                                </Table>

                            </div>
                            <div class="mt-3 d-lg-flex align-items-center text-center pb-1">
                                <div class="d-inline-block me-3">
                                    <label class="me-1">Display :</label>
                                    <select class="form-select d-inline-block w-auto" onChange={handlePaginateChange}>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                                <span class="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(total / paginate)}</strong> </span>
                                <RoundedPagination currentPage={page} totalPages={Math.ceil(total / paginate)} onPageChange={(pageNumber) => setPage(pageNumber)} />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <AddProduct show={showModal} onHide={() => hideModel()} editId={productID} />


            {loadingProduct && (<Preloader />)}
        </>
    );
};

export default Dashboard;
